export default __webpack_public_path__ + "static/media/analytics.4d24e4bd.svg";